// Client/src/utils/stateLrs/registry.js
// Per-state LRS adapter registry. Add a state by writing its adapter module
// (same interface as aldot.js / massdot.js) and registering it here — the gate
// (lrsGate.js) and the UI pick it up with no further changes.
//
// There is deliberately NO default state. Until 2026-07-27 every consumer
// imported a hardcoded DEFAULT_LRS_STATE = 'AL', which meant a project in Utah
// or Colorado silently issued spatial queries against Alabama; it looked
// harmless only because nothing ever landed within 150 m of an Alabama road.
// Callers must resolve a state through lrsGate.js and handle `null` (= this
// project is in a state we have no LRS for) as a first-class outcome.
import { aldotAdapter } from './aldot';
import { massdotAdapter } from './massdot';

const ADAPTERS = {
  AL: aldotAdapter,
  MA: massdotAdapter,
};

export function getLrsAdapter(stateCode) {
  if (!stateCode) return null;
  return ADAPTERS[String(stateCode).trim().toUpperCase()] ?? null;
}

export function isLrsStateSupported(stateCode) {
  return getLrsAdapter(stateCode) !== null;
}

/** [{ code, name }] for every registered state, for pickers. */
export function listLrsStates() {
  return Object.entries(ADAPTERS)
    .map(([code, adapter]) => ({ code, name: adapter.stateName }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
